import { render, staticRenderFns } from "./ClaimPauseDialog.vue?vue&type=template&id=2acb5ee8&"
import script from "./ClaimPauseDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimPauseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports